import { createFileRoute } from "@tanstack/react-router";
import { FaqPage } from "../pages/FaqPage";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { buildCompleteHead } from "../utils/seo";
import { LangProvider } from "../contexts/LangContext";
import { faqJsonLdScript } from "../data/faq";

export const Route = createFileRoute("/faq")({
  head: () => {
    const seoData = buildCompleteHead(
      "default",
      "faq",
      "https://lotin.uz/faq",
      "/faq",
      "/faq",
    );
    return {
      meta: [{ title: seoData.title }, ...seoData.meta],
      links: seoData.links,
      scripts: [faqJsonLdScript("uz-Latn")],
      htmlProps: { lang: "uz-Latn" },
    };
  },
  component: Faq,
});

function Faq() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    // Guard for SSR: only call changeLanguage if it exists
    if (i18n?.changeLanguage) {
      i18n.changeLanguage("default");
    }
  }, [i18n]);

  return (
    <LangProvider lang={"uz-Latn"}>
      <FaqPage lang="uz-Latn" />
    </LangProvider>
  );
}
